export default "__VITE_ASSET__BVoT16Q1__"